import reviewed from "./reviewed-v1.json";
import type { BankItem } from "../../engine/bank-types";
import { COMPREHENSION_ITEMS } from "./comprehension";
import { INTERPRETATION_ITEMS } from "./interpretation";
import { CONCEPT_ITEMS } from "./concept";
import { LINKAGE_ITEMS } from "./linkage";
import { CONFLICT_ITEMS } from "./conflict";
import { FIGURE_ITEMS } from "./figure";
import { APPLICATION_ITEMS } from "./application";
import { MISREAD_ITEMS } from "./misread";

/**
 * The authored question bank.
 *
 * Every item is hand-written against 楊伯峻《論語譯注》, tagged by chapter,
 * concept, figure, difficulty, cognitive level and learning purpose, and
 * carries a rationale for each option. `npm run check:bank` enforces the
 * quality standard in src/engine/quality.ts over the whole set.
 */
export const LEGACY_BANK_ITEMS: BankItem[] = [
  ...COMPREHENSION_ITEMS,
  ...INTERPRETATION_ITEMS,
  ...CONCEPT_ITEMS,
  ...LINKAGE_ITEMS,
  ...CONFLICT_ITEMS,
  ...FIGURE_ITEMS,
  ...APPLICATION_ITEMS,
  ...MISREAD_ITEMS,
];

export {
  COMPREHENSION_ITEMS,
  INTERPRETATION_ITEMS,
  CONCEPT_ITEMS,
  LINKAGE_ITEMS,
  CONFLICT_ITEMS,
  FIGURE_ITEMS,
  APPLICATION_ITEMS,
  MISREAD_ITEMS,
};

/** Exact accepted editorial versions apply only to newly issued questions. */
export const BANK_VERSION = reviewed.version;
export const BANK_ITEMS = reviewed.items as BankItem[];
